import React from "react";

//PropTypes
import PropTypes from "prop-types";

//UI Material
import { Modal, Button, Grid, Box } from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../Helpers/typography";

function ModalWindow({
  icon = <></>,
  isOpen = false,
  handleClose = () => null,
  title = "",
  text = "",
  leftText = "",
  rightText = "",
  leftClick = () => null,
  rightClick = () => null,
  rightColor = "secondary",
  leftColor = "secondary",
}) {
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 260,
          backgroundColor: "black",
          boxShadow: 2,
          borderRadius: "10px",
          p: 4,
          color: "white",
          textAlign: "center",
        }}
      >
        <Grid container alignItems="center" justifyContent="center" spacing={2}>
          <Grid item xs={12} md={12}>
            {typographyForSubtitles(title)}
          </Grid>
          <Grid item xs={12} md={12}>
            {typographyForText(text)}
          </Grid>
          <Grid item xs={6} md={6} sx={{ marginTop: "10px" }}>
            <Button
              size="small"
              variant="contained"
              color={leftColor}
              onClick={leftClick}
              sx={{ color: "white" }}
            >
              {leftText}
            </Button>
          </Grid>
          {rightText && (
            <Grid item xs={6} md={6} sx={{ marginTop: "10px" }}>
              <Button
                size="small"
                variant="contained"
                color={rightColor}
                onClick={rightClick}
                sx={{ color: "white" }}
              >
                {rightText}
              </Button>
            </Grid>
          )}
        </Grid>
      </Box>
    </Modal>
  );
}

// ==========>Component PropTypes<==========
ModalWindow.propTypes = {
  icon: PropTypes.element,
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  leftText: PropTypes.string.isRequired,
  rightText: PropTypes.string,
  leftClick: PropTypes.func.isRequired,
  rightClick: PropTypes.func,
  rightColor: PropTypes.string,
  leftColor: PropTypes.string,
};

export default ModalWindow;
